import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {Subscription} from 'rxjs';
import {MvsObjectNavigationService} from 'features/core/shared/navigation/mvs-object-navigation.service';
import {CpRunReviewLookupService} from '../../../service/ql/cp-run-review-lookup.service';
import {CpRunRowContract} from '../../../interface/cp-run-row-contract.interface';
import {cpOpenContract} from '../../../service/domain/cp-object-navigation';

/**
 * "Vertrag {VSNR} öffnen" — the navigation from an event row (`cp.ProvisionContract`) or a rate
 * row (`cp.ProvisionContractAgent`) of the run detail to the cm contract page.
 *
 * A read-only jump: it resolves the contract behind the row through QL and navigates to the cm
 * contract page with the `display` action — it never opens a form.
 */
@Component({
    selector: 'cp-run-detail-contract-link',
    templateUrl: './cp-run-detail-contract-link.component.html',
    styleUrls: ['./cp-run-detail-contract-link.component.scss'],
    standalone: false
})
export class CpRunDetailContractLinkComponent implements OnInit, OnChanges, OnDestroy {

    /** `cp.ProvisionContract` or `cp.ProvisionContractAgent` — both carry a `contract` FK. */
    @Input() objectType: string;

    @Input() objectId: number;

    initialized: boolean;
    contract: CpRunRowContract;
    loading: boolean;
    loadFailed: boolean;

    private loadSubscription: Subscription;

    constructor(protected lookupService: CpRunReviewLookupService,
                protected navigationService: MvsObjectNavigationService) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    /** Initialize component. */
    initComponent(): void {
        this.refreshComponent();
        this.initialized = true;
    }

    /** Resolve the contract behind the row; a skeleton shows meanwhile, a failure shows a disabled button. */
    refreshComponent(): void {

        this.loadSubscription?.unsubscribe();
        this.contract = null;
        this.loadFailed = false;
        this.loading = false;

        if (!this.objectType || !this.objectId) {
            return;
        }

        this.loading = true;

        this.loadSubscription = this.lookupService.loadRowContract(this.objectType, this.objectId).subscribe({
            next: contract => {
                this.contract = contract;
                this.loading = false;
            },
            error: () => {
                this.contract = null;
                this.loadFailed = true;
                this.loading = false;
            }
        });
    }

    /** Open the cm contract page of the resolved contract, read-only. */
    openContract(): void {
        cpOpenContract(this.navigationService, this.contract?.contractId);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['objectType'] || changes['objectId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
        this.loadSubscription?.unsubscribe();
    }
}
